/**
 * Generic utilities.
 */
export default class Utils {
    /**
     * Creates a downloadable file with the given specs.
     * @param text {string} The data in the file.
     * @param fileName {string} The name of the file (without extension).
     * @param mime {string} The mime type.
     */
    public static downloadData(text: string, fileName: string = "data", mime: string = "text/plain") {

        const element = document.createElement("a");
        element.setAttribute("href", `data:${mime};charset=utf-8,${encodeURIComponent(text)}`);
        element.setAttribute("download", fileName);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);

    }

    /**
     * Adds some metadata to the given json.
     * @param json {any} Any json.
     * @returns {any}
     */
    public static addKnwlInfo(json:any){
        json.origin = "https://knwl.space";
        json.date = (new Date()).getTime();
        return json;
    }
}
